import styles from './../styles/CtaButton.module.scss';
import { pushToDataLayer } from '../utils';
import React from 'react';

type ButtonProps = {
  text: string;
  color?: 'standard' | 'inverted';
  inNavbar?: boolean;
  customClassName?: string;
};

const CtaButton: React.FC<ButtonProps> = ({
  text,
  color,
  inNavbar,
  customClassName
}) => {
  const className = `${styles.ctaButton} ${
    color === 'inverted' ? styles.buttonInverted : styles.buttonStandard
  } ${inNavbar ? styles.inNavbar : ''} ${customClassName}`;

  const onClick = () => {
    pushToDataLayer('click_primary_CTA');
  };

  return (
    <a
      href={process.env.NEXT_PUBLIC_SURVEY_URL}
      className={className}
      onClick={onClick}
    >
      {text}
    </a>
  );
};

export default CtaButton;
